import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'
import '../assets/css/form.css'

class RaiseAccountForm extends Component {
    constructor () {
        super()
        this.state = {
            captchaSrc: '/xgj/v2/website/raiseAccount/captcha'
        }
    }


    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.getSubmitData(values, () =>{
                    this.getCaptcha()
                    this.props.form.resetFields()
                })
            }
        })
    }

    // 获取图片验证码
    getCaptcha = () => {
        this.setState({
            captchaSrc: `/xgj/v2/website/raiseAccount/captcha?t=${new Date().getTime()}`
        })    
    }


    render () {
        const { getFieldDecorator } = this.props.form
        return (
            <Form onSubmit={this.handleSubmit} style={{textAlign:'center'}}>
                <Form.Item>
                    {getFieldDecorator('accountNo', {
                        rules: [{ required: true, message: '证件号码不能为空' }],
                    })(
                        <Input
                        style={{
                            width: 320, 
                            height:40,
                        }}
                        prefix={<span>募集户账号：</span>}
                        placeholder="请输入基金合同内约定的募集户账号"
                        />,
                    )}
                    </Form.Item>
                    <Form.Item>
                    {getFieldDecorator('captcha', {
                        rules: [{ required: true, message: '验证码不能为空' }],
                    })(
                        <Input
                        style={{width: 230, height:40}}
                        prefix={<span>验证码：</span>}
                        placeholder="请输入验证码"
                        />,
                    )}
                    <span style={{width:87, height:40, display:'inline-block', position: 'relative', verticalAlign:'top', marginLeft:3, textAlign:'right'}}>
                        <img src={this.state.captchaSrc} alt="validSrc" style={{width:87, height:40}}/>
                        <Button type="link" style={{position:'absolute', right:0, bottom: -30,fontSize:'10px'}} onClick={this.getCaptcha}>看不清，换一张</Button>
                    </span>
                    </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" style={{width:320, height:36, color:'#fff', backgroundColor:'#435EEB'}}>查询</Button>
                </Form.Item>
            </Form>
        )
    }
}

export default Form.create()(RaiseAccountForm)